module.exports = __webpack_public_path__ + "static/media/cancel-service_1.5202f4fd.png";